export const games = [
  {
    id: 1,
    title: 'CLANNAD 汉化版',
    slug: 'clannad-hanhua',
    category: 'hanhua',
    image: 'https://readdy.ai/api/search-image?query=Anime%20visual%20novel%20CLANNAD%20game%20cover%20art%20with%20cherry%20blossom%20and%20school%20building%20background%2C%20warm%20sunset%20lighting%2C%20soft%20pastel%20colors%2C%20clean%20minimal%20design%2C%20Japanese%20visual%20novel%20aesthetic%2C%20emotional%20atmosphere&width=800&height=600&seq=game-clannad-01&orientation=landscape',
    description: 'Key社经典催泪神作，讲述高中生冈崎朋也与少女们在樱花树下相遇的感人故事。小镇与家族的羁绊、梦想与现实的交织，带来最深刻的青春体验。',
    rating: 9.6,
    downloads: 256000,
    size: '3.2GB',
    platform: 'Windows 7/10/11',
    date: '2024-01-15',
    tags: ['催泪', '校园', 'Key社', '全年龄'],
    isHot: true,
    isNew: false,
  },
  {
    id: 2,
    title: 'Steins;Gate 命运石之门',
    slug: 'steins-gate',
    category: 'hanhua',
    image: 'https://readdy.ai/api/search-image?query=SteinsGate%20visual%20novel%20game%20cover%20featuring%20futuristic%20lab%20equipment%20and%20time%20travel%20themes%2C%20dark%20atmospheric%20lighting%2C%20sci-fi%20aesthetic%2C%20clean%20composition%2C%20modern%20anime%20art%20style&width=800&height=600&seq=game-steinsgate-02&orientation=landscape',
    description: '5pb.与Nitro+合作打造的科幻悬疑神作。秋叶原为舞台，一群大学生偶然发明了能向过去发送邮件的时间机器，由此卷入关乎世界命运的阴谋之中。',
    rating: 9.5,
    downloads: 198000,
    size: '4.5GB',
    platform: 'Windows 10/11',
    date: '2023-11-20',
    tags: ['科幻', '悬疑', '时间旅行', '秋叶原'],
    isHot: true,
    isNew: false,
  },
  {
    id: 3,
    title: 'Fate/stay night [Realta Nua]',
    slug: 'fate-stay-night',
    category: 'hanhua',
    image: 'https://readdy.ai/api/search-image?query=Fate%20stay%20night%20visual%20novel%20game%20cover%20with%20heroic%20spirit%20summoning%20circle%20and%20magical%20effects%2C%20epic%20fantasy%20atmosphere%2C%20dark%20blue%20and%20gold%20color%20scheme%2C%20anime%20art%20style%2C%20clean%20layout&width=800&height=600&seq=game-fate-03&orientation=landscape',
    description: 'TYPE-MOON出品的传奇视觉小说。七位魔术师与七位英灵在冬木市展开圣杯战争，少年卫宫士郎意外卷入这场关乎愿望与信念的终极对决。',
    rating: 9.4,
    downloads: 320000,
    size: '6.8GB',
    platform: 'Windows 7/10/11',
    date: '2024-03-08',
    tags: ['奇幻', '战斗', 'TYPE-MOON', '全语音'],
    isHot: true,
    isNew: false,
  },
  {
    id: 4,
    title: '白色相簿2 终章',
    slug: 'white-album-2',
    category: 'hanhua',
    image: 'https://readdy.ai/api/search-image?query=White%20Album%202%20visual%20novel%20game%20cover%20with%20winter%20snow%20scene%20and%20music%20themes%2C%20romantic%20melancholic%20atmosphere%2C%20piano%20keys%20and%20falling%20snow%2C%20soft%20white%20and%20light%20blue%20tones%2C%20emotional%20anime%20art&width=800&height=600&seq=game-wa2-04&orientation=landscape',
    description: 'Leaf社恋爱题材巅峰之作。雪夜中的校园，三人之间的感情纠葛，被奉为"脱宅神作"的恋爱冒险游戏，令人心碎又难忘的冬日物语。',
    rating: 9.3,
    downloads: 185000,
    size: '7.2GB',
    platform: 'Windows 10/11',
    date: '2024-02-14',
    tags: ['恋爱', '校园', '音乐', 'Leaf社'],
    isHot: false,
    isNew: true,
  },
  {
    id: 5,
    title: '沙耶之歌',
    slug: 'saya-no-uta',
    category: 'hanhua',
    image: 'https://readdy.ai/api/search-image?query=Saya%20no%20Uta%20visual%20novel%20game%20cover%20with%20surreal%20organic%20landscape%20and%20horror%20elements%2C%20dark%20atmospheric%20lighting%2C%20psychological%20horror%20theme%2C%20grotesque%20beauty%20contrast%2C%20Nitroplus%20art%20style&width=800&height=600&seq=game-saya-05&orientation=landscape',
    description: 'Nitro+出品的异色恐怖视觉小说。一场事故后，主角眼中的世界变成了血肉与内脏的噩梦，唯有名为沙耶的少女是他眼中唯一的美好。',
    rating: 8.9,
    downloads: 95000,
    size: '1.5GB',
    platform: 'Windows 7/10/11',
    date: '2023-09-30',
    tags: ['恐怖', '猎奇', 'Nitro+', '短篇'],
    isHot: false,
    isNew: false,
  },
  {
    id: 6,
    title: 'G線上の魔王',
    slug: 'g-senjou-no-maou',
    category: 'hanhua',
    image: 'https://readdy.ai/api/search-image?query=G-senjou%20no%20Maou%20visual%20novel%20game%20cover%20with%20classical%20music%20and%20mystery%20themes%2C%20violin%20and%20chess%20motifs%2C%20dark%20elegant%20atmosphere%2C%20psychological%20thriller%20vibe%2C%20anime%20art%20style&width=800&height=600&seq=game-gsenjou-06&orientation=landscape',
    description: '车轮之国制作团队又一力作。少女与"魔王"之间的智斗与情感交织，古典音乐为背景的犯罪悬疑故事，结局令人震撼。',
    rating: 9.1,
    downloads: 142000,
    size: '2.8GB',
    platform: 'Windows 7/10/11',
    date: '2023-12-25',
    tags: ['悬疑', '智斗', '古典音乐', '催泪'],
    isHot: false,
    isNew: false,
  },
  {
    id: 7,
    title: '千恋＊万花',
    slug: 'senren-banka',
    category: 'riwen',
    image: 'https://readdy.ai/api/search-image?query=Senren%20Banka%20visual%20novel%20game%20cover%20with%20Japanese%20hot%20spring%20town%20and%20katana%20motif%2C%20traditional%20Japanese%20aesthetic%2C%20cherry%20blossom%20petals%2C%20warm%20and%20romantic%20atmosphere%2C%20Yuzusoft%20art%20style&width=800&height=600&seq=game-senren-07&orientation=landscape',
    description: 'ゆずソフト制作の人気和風恋愛ADV。温泉街を舞台に、巫女や忍者など個性豊かなヒロインたちとの恋物語が繰り広げられる。',
    rating: 9.0,
    downloads: 110000,
    size: '5.1GB',
    platform: 'Windows 10/11',
    date: '2024-04-01',
    tags: ['和風', '恋愛', 'ゆずソフト', '温泉'],
    isHot: true,
    isNew: true,
  },
  {
    id: 8,
    title: 'Ever17 -the out of infinity-',
    slug: 'ever17',
    category: 'hanhua',
    image: 'https://readdy.ai/api/search-image?query=Ever17%20visual%20novel%20game%20cover%20with%20underwater%20theme%20park%20and%20mystery%20elements%2C%20deep%20ocean%20blue%20atmosphere%2C%20science%20fiction%20and%20suspense%2C%20clean%20anime%20art%20style%2C%20mysterious%20ambiance&width=800&height=600&seq=game-ever17-08&orientation=landscape',
    description: 'KID社出品的科幻悬疑名作。海底主题公园发生事故，七名被困者必须在有限的氧气中寻找出路，双视角叙述带来惊人的真相揭露。',
    rating: 9.2,
    downloads: 87000,
    size: '2.1GB',
    platform: 'Windows 7/10/11',
    date: '2023-07-15',
    tags: ['科幻', '悬疑', 'KID社', '经典'],
    isHot: false,
    isNew: false,
  },
  {
    id: 9,
    title: '穢翼のユースティア',
    slug: 'aisuru-yuustia',
    category: 'hanhua',
    image: 'https://readdy.ai/api/search-image?query=Aiyoku%20no%20Eustia%20visual%20novel%20game%20cover%20with%20floating%20city%20and%20dark%20fantasy%20themes%2C%20angel%20wings%20motif%2C%20medieval%20fantasy%20atmosphere%2C%20dramatic%20lighting%2C%20anime%20art%20style%2C%20epic%20scale&width=800&height=600&seq=game-yuustia-09&orientation=landscape',
    description: 'AUGUST社打造的黑暗幻想史诗。漂浮在空中的城市、蔓延的疾病、阶层的对立，少女尤斯蒂娅背负着改变世界的命运。',
    rating: 9.0,
    downloads: 76000,
    size: '4.2GB',
    platform: 'Windows 7/10/11',
    date: '2023-06-10',
    tags: ['黑暗幻想', '史诗', 'AUGUST', '催泪'],
    isHot: false,
    isNew: false,
  },
  {
    id: 10,
    title: '9-nine- 系列合集',
    slug: '9-nine-collection',
    category: 'hanhua',
    image: 'https://readdy.ai/api/search-image?query=9-nine%20visual%20novel%20game%20cover%20with%20urban%20fantasy%20and%20superpower%20themes%2C%20modern%20city%20background%2C%20mystical%20artifacts%2C%20stylish%20anime%20art%2C%20cool%20color%20palette%2C%20clean%20composition&width=800&height=600&seq=game-9nine-10&orientation=landscape',
    description: 'Palette出品超能力校园物语合集。拥有异能之力的少年少女们对抗神秘连续杀人事件，四部曲完整收录，体验完整的超自然冒险。',
    rating: 8.8,
    downloads: 68000,
    size: '12.5GB',
    platform: 'Windows 10/11',
    date: '2024-05-20',
    tags: ['超能力', '校园', '悬疑', '合集'],
    isHot: false,
    isNew: true,
  },
  {
    id: 11,
    title: 'Muv-Luv Alternative',
    slug: 'muv-luv-alternative',
    category: 'hanhua',
    image: 'https://readdy.ai/api/search-image?query=Muv-Luv%20Alternative%20visual%20novel%20game%20cover%20with%20mecha%20and%20alien%20invasion%20themes%2C%20military%20sci-fi%20atmosphere%2C%20giant%20robots%20battle%20scene%2C%20dramatic%20and%20epic%20scale%2C%20anime%20art%20style&width=800&height=600&seq=game-muvluv-11&orientation=landscape',
    description: 'âge社打造的史诗级科幻巨作。平行世界、外星入侵、战术机战斗，在全球玩家评分网站长期霸榜的传奇视觉小说。',
    rating: 9.7,
    downloads: 215000,
    size: '8.6GB',
    platform: 'Windows 10/11',
    date: '2024-01-01',
    tags: ['科幻', '机甲', '史诗', '催泪'],
    isHot: true,
    isNew: false,
  },
  {
    id: 12,
    title: 'ATRI -My Dear Moments-',
    slug: 'atri-my-dear-moments',
    category: 'hanhua',
    image: 'https://readdy.ai/api/search-image?query=ATRI%20visual%20novel%20game%20cover%20with%20ocean%20and%20robot%20girl%20themes%2C%20seaside%20town%20setting%2C%20warm%20sunset%20colors%2C%20heartwarming%20atmosphere%2C%20beautiful%20anime%20art%20style%2C%20emotional%20and%20gentle&width=800&height=600&seq=game-atri-12&orientation=landscape',
    description: 'ANIPLEX.EXE出品暖心短篇。海平面上升后的世界，失去一切的少年与机器人少女亚托莉相遇，一段关于时间、记忆与爱的故事。',
    rating: 9.1,
    downloads: 165000,
    size: '2.3GB',
    platform: 'Windows 10/11',
    date: '2024-06-15',
    tags: ['科幻', '治愈', '短篇', '机器人'],
    isHot: false,
    isNew: true,
  },
];

export const hotGames = games.filter(g => g.isHot);
export const newGames = games.filter(g => g.isNew);

export function getGameById(id: number) {
  return games.find(g => g.id === id);
}

export function getGamesByCategory(slug: string) {
  return games.filter(g => g.category === slug);
}